import { links as aboutLinks } from '../../components/footer/link-groups/about-links/links';
import { links as customerServiceLinks } from '../../components/footer/link-groups/customer-service-links/links';
import { links as experienceLinks } from '../../components/footer/link-groups/experience-links/links';
import { PageUrl } from '../../pages/utils/page-url';
import type { RawUrl } from '../../utils/api';

export const preloadUrls: RawUrl[] = [...customerServiceLinks, ...aboutLinks, ...experienceLinks]
    .map((x) => x.url)
    .concat([
        {
            action: PageUrl.SEARCH_SHOW,
        },
        {
            action: PageUrl.SG_CART,
        },
        {
            action: PageUrl.SITE_MAP,
        },
        {
            action: PageUrl.STORES_FIND,
        },
        {
            action: PageUrl.STORES_FIND,
            args: [],
        },
        {
            action: PageUrl.STORES_FIND,
            args: ['StoreID', ''],
        },
        {
            action: PageUrl.HOME_SHOW,
        },
        {
            action: PageUrl.WISHLIST,
        },
        {
            action: PageUrl.ACCOUNT_SHOW,
        },
        {
            action: PageUrl.CUSTOMER_CONTACT_US,
        },
        {
            action: PageUrl.ORDERS_HISTORY,
        },
        {
            action: PageUrl.GIFT_REGISTRY_START,
        },
        {
            action: PageUrl.LOGOUT,
            args: [],
        },
        {
            action: PageUrl.PAGE_SHOW,
            args: ['cid', 'email_signup_15_off_75_details', 'format', 'ajax'],
        },
        {
            action: PageUrl.ORDERS_HISTORY,
        },
    ])
    .map((item) => (item.args ? item : { ...item, args: [] }));
